<template>
    <v-card
      elevation="5"          
      class="text-uppercase pl-10 pr-10"
    >
      <v-card-title class="justify-center">Datos sociodemogràficos</v-card-title>

      <v-card-text v-if="!answerReady">
        <v-row no-gutters>
          <v-col cols="12">
            <h4 class="text-center"> 
             ¿Es la primera vez que haces este test?
            </h4>
          </v-col>
          <v-col cols="12">                 
              <v-btn
              class="ma-2"           
              @click="setFirstTime(true)"
            >
              SÍ
            </v-btn>
            <v-btn
              class="ma-2"
              @click="setFirstTime(false)"
            >
              NO
            </v-btn>
          </v-col>
        </v-row>        
      </v-card-text>

      <v-card-text v-if="!firstTime && answerReady">
         <v-row no-gutters>
          <v-col cols="12">
            <h4 v-if="userAlreadyExist" class="text-left"> 
              Hemos detectado que tu usuario ya existe por favor continua a partir de aqui
            </h4>
            <h4 class="text-left"> 
              Por favor, introduce tu codigo de usuario. Ejemplo (Eduardo, 01/05/1978): Código ED051978
            </h4>
          </v-col>
          <v-col cols="6">                 
             <v-text-field label="Ej. ED051978"
                          type="text"
                          v-model="userId"
                          :rules="[rules.required,rules.counter,rules.userId]"
                          >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters>
        <v-col cols="12">
          <v-btn v-on:click="nextCardUserExist()"
                :disabled="userId.length != 8 || !/[A-Z]{2}[0-9]{6}/.test(userId)">Siguiente</v-btn>
        </v-col>
      </v-row>
      </v-card-text>

      <v-card-text v-if="firstTime && answerReady">
        <v-row no-gutters>
          <v-col cols="12">
            <h4 class="text-left"> Por favor, indica con cual de los siguientes géneros gramaticales te identificas, esto determinará el género gramatical de distintos adjetivos que te serán presentados. El objetivo de esta pregunta no está relacionado con la identidad de género, sencillamente nos ayudará a determinar el género gramatical en que se te presentarán distintos adjetivos que en algunos momentos de la tarea se referirán a ti mism@, y sobre los cuales deberás autoevaluarte en algún momento. Por tanto, elige en qué género gramatical quieres que te aparezcan aquellos adjetivos que no sean neutros:</h4>
          </v-col>
          <v-col cols="6">                 
            <v-select
              v-model="userGender"
              :items="genders"
              item-text="value"
              item-value="id"
              label="Género"                  
            ></v-select> 
          </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12">
            <h4 class="text-left"> Indícanos tu edad</h4>
          </v-col>
          <v-col cols="6"> 
            <v-text-field label="Edad (número)"
                          type="number"
                          v-model.number="userAge"
                          >
            </v-text-field>
          </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12">
            <h4 class="text-left"> Indícanos tu nivel de estudios</h4>
          </v-col>
          <v-col cols="6"> 
            <v-select
              :items="studies"
              item-text="value"
              item-value="id"
              label="Estudios"
              v-model="userStudies"                
            ></v-select>
          </v-col>
        </v-row>

        <v-row no-gutters>
            <v-col cols="12">
            <h4 class="text-left"> ¿En cuántas obras de teatro (o similar) has participado a cualquier nivel durante los últimos 20 años? </h4>
          </v-col>
          <v-col cols="6"> 
            <v-text-field label="Funciones (número)"
                          type="number"
                          v-model.number="userNumEvents"
                          >
            </v-text-field>
          </v-col>
        </v-row>

        <v-row no-gutters>
          <v-col cols="12">
            <h4 class="text-left"> 
              Por favor, elige un Código que servirá para poder conectar tus respuestas entre si. Es importante que lo recuerdes o lo anotes, 
              sino tus respuestas se perderán. El código debe contener 2 letras en MAYÚSCULAS y 6 números. Para las letras utiliza las dos primeras 
              letras de tu nombre. Para los números el mes y el año de tu Nacimiento. Ejemplo (Eduardo, 01/05/1978): Código ED051978</h4>
          </v-col>
          <v-col cols="6">                 
            <v-text-field label="Ej. ED051978"
                          type="text"
                          v-model="userId"
                          :rules="[rules.required,rules.counter,rules.userId]"
                          >
            </v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="12">
            <v-btn v-on:click="next()" :disabled="!formValidation()">Siguiente</v-btn>
          </v-col>
        </v-row>
      </v-card-text>        
    </v-card>        
</template>

<script>
  import * as data from '../../tools/data'
  import * as api from '../../tools/api'

  export default {
    name: 'RegisterCard',

    data: () => ({
      firstTime: false,
      answerReady: false,
      userAlreadyExist: false,
      rules: {
          required: value => !!value || 'Necesario.',
          counter: value => value.length == 8 || 'Exactamente 8 caracteres',
          userId: value => {
            const pattern = /[A-Z]{2}[0-9]{6}/
            return pattern.test(value) || 'Sigue el ejemplo ED051978.'
          },   
      }
    }),
    mounted(){
      this.$store.dispatch('setSessionId',new Date().getTime())
    },
    methods:{
      async next(){
        let user = await api.checkIfUserExist(this.$store.state.apiUri,this.userId)

        if (this.firstTime && Object.keys(user).length>0){
          this.userGender =  user.gender
          this.userStudies = user.studies
          this.userAge = user.age
          this.userNumEvents = user.events
          this.userId = user.code

          this.userAlreadyExist = true
          this.firstTime = false
          this.$store.dispatch('setUserData',user)
        }else if (this.firstTime && Object.keys(user).length == 0){
          this.nextCardNewUser()
        }
      },
      async nextCardUserExist(){
        if(!this.userAlreadyExist){
          let user = await api.checkIfUserExist(this.$store.state.apiUri,this.userId)
          this.userGender =  user.gender
          this.userStudies = user.studies
          this.userAge = user.age
          this.userNumEvents = user.events
          this.userId = user.code
          this.$store.dispatch('setUserData',user)
        }
        this.$store.dispatch('nextCard') 
      },
      async nextCardNewUser(){
        let user = {
          gender: this.userGender,
          studies: this.userStudies,
          age: this.userAge,
          events: this.userNumEvents,
          code: this.userId
        }
        let resp = await api.createUser(this.$store.state.apiUri,user)
            console.log("**",resp)
            this.$store.dispatch('setUserData',resp)
            this.$store.dispatch('nextCard')               
      },
      setFirstTime(value){
        this.firstTime = value
        this.answerReady = true
      },
      formValidation(){
        if (this.userGender == 0)
          return false
        else if(this.userStudies == 0)
          return false
        else if(this.userAge == 0)
          return false
        else if(this.userId.length != 8 || !/[A-Z]{2}[0-9]{6}/.test(this.userId))
          return false
        else 
          return true
      }
    },
    computed:{
      genders(){
        return data.genders
      },
      studies(){
        return data.studies
      },
      userGender:{
        get(){
          return this.$store.state.genderId
        },
        set(value){
          this.$store.dispatch('setGender',value)
        }
      },
      userStudies:{
        get(){
          return this.$store.state.studiesId
        },
        set(value){
          this.$store.dispatch('setStudies',value)
        }
      },
      userAge:{
        get(){
          return this.$store.state.age
        },
        set(value){
          this.$store.dispatch('setAge',value)
        }
      },
      userId:{
        get(){
          return this.$store.state.userId
        },
        set(value){
          this.$store.dispatch('setUserId',value)
        }
      },
      userNumEvents:{
        get(){
          return this.$store.state.numEvents
        },
        set(value){
          this.$store.dispatch('setNumEvents',value)
        }
      }
    }
  }
</script>
